module.exports = __webpack_public_path__ + "a1e8ff1d32be0dd644ba4979d83ffba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/commons/default_picture.png
// module id = 105
// module chunks = 0